import { render } from "./HomeEducation.vue?vue&type=template&id=3e8c89fd&scoped=true"
import script from "./HomeEducation.vue?vue&type=script&lang=js"
export * from "./HomeEducation.vue?vue&type=script&lang=js"

import "./HomeEducation.vue?vue&type=style&index=0&id=3e8c89fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c89fd"]])

export default __exports__